import { Centered } from 'components/core-v2'
import { LoadingSpinner } from 'components/core-v2/atoms/loading-spinner'
import { ClassName } from 'types/props'

export const Loading = ({ className }: ClassName) => (
  <Centered className={className}>
    <LoadingSpinner />
  </Centered>
)
